import { FaArrowRight, FaEye, FaLock, FaUserShield, FaServer } from "react-icons/fa";
import { FaShield } from "react-icons/fa6";

export default function SecurityInformation() {
    return (
        <section
            id="security"
            className="py-20 px-6 lg:px-16 bg-gradient-to-br from-[#00274D] to-[#001C36] text-white overflow-hidden"
        >
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
                
                <div>
                    <div className="inline-flex items-center justify-center bg-[#0081FF]/10 border border-[#0081FF]/30 rounded-full px-6 py-2 mb-6">
                        <FaShield className="w-5 h-5 text-[#FFC107] mr-2" />
                        <span className="text-[#FFC107] font-semibold">Komitmen Keamanan Informasi</span>
                    </div>

                    <h2 className="text-4xl sm:text-5xl font-bold mb-6 leading-snug">
                        Keamanan Informasi Anda <br /> Adalah Prioritas Kami
                    </h2>

                    <p className="text-blue-100 mb-8 text-lg max-w-lg">
                        <b>BPR Palu Anugerah</b> berkomitmen menerapkan Sistem Manajemen Keamanan Informasi
                        berdasarkan <strong>ISO 27001:2022</strong> untuk memastikan kerahasiaan, integritas,
                        dan ketersediaan informasi Anda di bawah kendali dan pengawasan yang ketat.
                    </p>

                    <a href="/kebijakan-keamanan-informasi" className="bg-[#FFC107] text-[#00274D] font-semibold px-8 py-4 rounded-xl inline-flex items-center gap-2 hover:bg-[#FFD740] transition-transform transform hover:scale-105 shadow-md hover:shadow-lg">
                        <span>Pelajari Kebijakan Keamanan</span>
                        <FaArrowRight className="w-5 h-5" />
                    </a>

                    <p className="text-blue-200 mt-4 text-sm">
                        Baca lebih lanjut tentang bagaimana kami menjaga keamanan dan kerahasiaan data nasabah.
                    </p>
                </div>

                <div className="space-y-6">

                    <div className="flex items-start gap-5 bg-white/5 border border-[#0081FF]/20 backdrop-blur-lg rounded-2xl p-6 hover:border-[#0081FF]/50 hover:shadow-lg hover:shadow-[#0081FF]/20 transition-all duration-300">
                        <div className="bg-[#0081FF] w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0">
                            <FaLock className="w-6 h-6 text-white" />
                        </div>
                        <div>
                            <h3 className="text-xl font-semibold mb-1">Kerahasiaan & Integritas Data</h3>
                            <p className="text-blue-100">
                                Informasi dan dokumen dijaga agar tetap rahasia, utuh, dan hanya dapat diakses oleh pihak berwenang.
                            </p>
                        </div>
                    </div>

                    <div className="flex items-start gap-5 bg-white/5 border border-[#0081FF]/20 backdrop-blur-lg rounded-2xl p-6 hover:border-[#0081FF]/50 hover:shadow-lg hover:shadow-[#0081FF]/20 transition-all duration-300">
                        <div className="bg-[#FFC107] w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0">
                            <FaServer className="w-6 h-6 text-[#00274D]" />
                        </div>
                        <div>
                            <h3 className="text-xl font-semibold mb-1">Lingkungan Aman & Terkendali</h3>
                            <p className="text-blue-100">
                                Data disimpan dalam lingkungan yang aman, terkendali, dan terlindungi dari akses atau pengungkapan tidak sah.
                            </p>
                        </div>
                    </div>

                    <div className="flex items-start gap-5 bg-white/5 border border-[#0081FF]/20 backdrop-blur-lg rounded-2xl p-6 hover:border-[#0081FF]/50 hover:shadow-lg hover:shadow-[#0081FF]/20 transition-all duration-300">
                        <div className="bg-gradient-to-r from-[#0081FF] to-[#00B3FF] w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0">
                            <FaUserShield className="w-6 h-6 text-white" />
                        </div>
                        <div>
                            <h3 className="text-xl font-semibold mb-1">Perlindungan Teknis & Fisik</h3>
                            <p className="text-blue-100">
                                Kami menjaga keamanan administratif, teknis, dan fisik terhadap akses, modifikasi,
                                atau penggunaan tidak sah atas data pribadi nasabah.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}
